import { Pipe, PipeTransform } from '@angular/core';
import { StatusPill } from '../../../models/shared/status-pill';
import { MemberAccountStatus } from '../../../models/transactions/member-account-status';
import { buildAccountStatusPill } from '../../../utils/account-status-pill-utils';

@Pipe({
  name: 'accountStatusPill',
  standalone: true
})
export class AccountStatusPillPipe implements PipeTransform {
  transform(status: MemberAccountStatus): StatusPill {
    return buildAccountStatusPill(status);
  }
}
